import { TypedDocumentNode, gql } from "@apollo/client";

interface EventsData {
  events: EventsInterface;
}

export enum TimeLineView {
  UPCOMING = "Upcoming",
  COMPLETED = "Completed",
  ALL = "All",
}
export enum EventType {
  WEBINAR = "Webinar",
  COURSE = "Course",
}

type EventParams = {
  slug?: string;
  country?: string;
  city?: string;
  page?: number;
  perPage?: number;
  date?: string;
  modeOfTraining?: string;
  eventType?: EventType;
  timeLineView?: TimeLineView;
};

export const GET_EVENTS: TypedDocumentNode<EventsData, EventParams> = gql`
  query GetEvents(
    $slug: String!
    $country: String
    $city: String
    $page: Int
    $perPage: Int
    $date: String
    $modeOfTraining: String
    $eventType: EventType
    $timeLineView: TimeLineView
  ) {
    events(
      page_slug: $slug
      country_code: $country
      city_slug: $city
      page: $page
      perPage: $perPage
      date: $date
      modeOfTraining: $modeOfTraining
      eventType: $eventType
      timeLineView: $timeLineView
    ) {
      data {
        id
        serviceId
        pageSlug
        numberOfLearners
        eventName
        eventDescription
        serviceEventTitle
        serviceName
        serviceImage
        startDate
        endDate
        eventDates
        eventDate
        serviceTrainingDays
        withExam
        status
        modeOfTraining
        eventType
        isEarlyBirdOfferApplied
        isAdvanceOfferApplied
        eventCloseDate
        isFastFilling
        hasMappedService
        offerId
        eventDetail {
          id
          regionType
          startTime
          endTime
          eventTime
          timeDiffInHours
          price
          currencySymbol
          currency
          timezone
          locationType
          discountPercent
          discountPercentNumber
          discountValue
          discountValueNumber
          trainer {
            name
            email
            image
            trainer_code
            primary_contact
            secondary_contact
            address_line1
            address_line2
            experience
            expertise
          }
        }
        offers {
          id
          name
          discountPercentage
          couponCode
          totalQuantity
          startDayBefore
          endDayBefore
          startDate
          endDate
          offerAppliedPerParticipantQuantity
          minimumRequiredQuantity
          minimumCost
          offerTypeConstantValueId
          description
          terms
        }
      }
      pageInfo {
        count
        currentPage
        perPage
        lastPage
        total
        next_page
        prev_page
      }
    }
  }
`;
